<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        Recuperar contraseña
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form class="space-y-6" @submit.prevent="handleForgot">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">
              Correo electrónico
            </label>
            <div class="mt-1">
              <input id="email" name="email" type="email" autocomplete="email" required v-model="email"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm">
            </div>
          </div>

          <div>
            <button type="submit" :disabled="loading"
              class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50">
              <span v-if="loading">Enviando...</span>
              <span v-else>Enviar enlace de recuperación</span>
            </button>
          </div>

          <div v-if="message" class="text-green-600 text-sm text-center mt-2">
            {{ message }}
          </div>

          <div v-if="error" class="text-red-600 text-sm text-center mt-2">
            {{ error }}
          </div>

          <div class="text-center mt-4">
            <router-link to="/login" class="font-medium text-primary hover:text-indigo-500 text-sm">
              Volver al inicio de sesión
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      loading: false,
      message: null,
      error: null
    }
  },
  methods: {
    ...mapActions('auth', ['forgotPassword']),
    async handleForgot() {
      this.loading = true
      this.error = null
      this.message = null
      try {
        const response = await this.forgotPassword(this.email)
        this.message = response.message
      } catch (err) {
        this.error = err.response?.data?.message || 'Ocurrió un error al procesar su solicitud.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
